/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Export_Vchip_Type_MpaaInputs */



/**
* | output |
* | --- |
* | "MPAA" |
*
* @param {Subtitle_Export_Vchip_Type_MpaaInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_export_vchip_type_mpaa = /** @type {((inputs?: Subtitle_Export_Vchip_Type_MpaaInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Export_Vchip_Type_MpaaInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("MPAA")
	if (locale === "de") return /** @type {LocalizedString} */ ("MPAA")
	if (locale === "it") return /** @type {LocalizedString} */ ("MPAA")
	if (locale === "ru") return /** @type {LocalizedString} */ ("MPAA")
	if (locale === "es") return /** @type {LocalizedString} */ ("Asociación Médica Popular")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("美国电影协会")
	if (locale === "ja") return /** @type {LocalizedString} */ ("MPAA")
	if (locale === "hi") return /** @type {LocalizedString} */ ("एमपीएए")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("MPAA")
	return /** @type {LocalizedString} */ ("MPAA")
});